export { DockDoorSearchBar } from './DockDoorSearchBar';
export { DockDoorTable } from './DockDoorTable';
export { StatusToggleButton } from './StatusToggleButton';

/** Normalize dock door status — replaces legacy 'Open' with 'Available'. */
export function normalizeStatus(status: string): string {
  return status.replace('Open', 'Available');
}
